"use strict";
var Observable_1 = require('../../Observable');
var concat_1 = require('../../operator/concat');
Observable_1.Observable.prototype.concat = concat_1.concat;
//# sourceMappingURL=concat.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/EZepeda/Desktop/Explora/adminexplora/~/rxjs/add/operator/concat.js
// module id = ../../../../rxjs/add/operator/concat.js
// module chunks = 4